module.exports = __webpack_public_path__ + "img/u161.830546bc.svg";